import * as a from '../actions/cost'
import { createReducer } from 'redux-act'
var month = (new Date().getMonth() + 1);

  let DEFAULT_STATE = {
    costs: [],
    allCost: [],
    uploads: {
      photos: [],
      show: false
    },
    showReportsPage: false,
    filter: {
      status: "manager",
      year: new Date().getFullYear(),
      month: -1
    }
  }
  export default createReducer(
    {
      [a.fetchCostListSuccessful]: (state, payload) => {
        if (!payload.new) {
          return Object.assign({}, state, {
            allCost: payload
          });
        } else {
          if (state.allCost.length > 0) {
            var reverse = state.allCost.reverse();
            reverse.forEach((data) => {
              payload.unshift(data);
            });
          }
          return Object.assign({}, state, {
            allCost: payload
          });
        }
      },
      [a.fetchCostListFailure]: (state, payload) => {
        return {
          ...state
        }
      },
      [a.manageCostPhotoUpload]: (state, payload) => {
        return Object.assign({}, state, {
          uploads: {
            show: payload,
            photos: state.uploads.photos
          }
        });
      },
      [a.addCostPhoto]: (state, payload) => {
        if (!payload.update) {
          return {
            ...state,
            uploads: {
              photos: state.uploads.photos.concat(payload),
              show: true
            }
          };
        } else {
          var map = state.uploads.photos.map((d, i) => {
            if (d.costId == payload.costId && d.lastModified == payload.lastModified) {
              d.photoLink = payload.photoLink;
              d.status = payload.status;
              return d;
            } else {
              return d;
            }
          });
          return Object.assign({}, state, {
            uploads: {
              photos: map,
              show: true
            }
          });
        }
      },
      [a.deleteCostPhotoSuccessful]: (state, payload) => {
        const map = state.costs.map((d) => {
          if (d.firstCost && d.firstCost.costPhotos.length > 0) {
            d.firstCost.costPhotos.forEach((v, i) => {
              if (v.data._id == payload) {
                delete d.firstCost.costPhotos[i];
                if (d.firstCost.costPhotos.length == 1)
                  d.costPhotos = [];
              }
            });
            return d;
          } else {
            return d;
          }
        });
        return {
          ...state,
          costs: map
        };
      },
      [a.deleteCostPhotoFailure]: (state, payload) => {
        return {
          ...state
        }
      },
      [a.setCostFilter]: (state, payload) => {
        if (!payload.status) {
          payload = {
            status: state.filter.status,
            year: state.filter.year,
            month: state.filter.month
          }
        } else {
          if (payload.year == -1)
            payload.year = window.costStartingYear;
        }
        return {
          ...state,
          costs: state.allCost.map((data) => {
            let costs = data.costs;
            let group = {
              groupId: data.groupId,
              firstCost: {},
              subCost: []
            };
            costs.forEach((cost) => {
              if (!group.firstCost.costId)
                group.firstCost = cost;
              else
                group.subCost.push(cost);

            });
            if (group.firstCost.costId)
              return group;
            else
              return null;
          }).filter((data) => { return data }),
          filter: payload
        }
      },
    },
    DEFAULT_STATE
  );